/* Draft-theme compatibility for legacy navigation/app links. Native section
   settings also point directly at the new quiz. No shared Shopify menu edits. */
(function () {
  'use strict';
  var script = document.currentScript;
  var target = script && script.getAttribute('data-quiz-url');
  if (!target) return;
  function legacy(link) {
    var href = link.getAttribute('href');
    if (!href) return false;
    if (/^#quiz-[a-z0-9]+$/i.test(href)) return true;
    try {
      var url = new URL(href, location.href);
      if (!/^(www\.)?infraredi\.(com|com\.au|ca|co\.uk|co\.nz)$/.test(url.hostname)) return false;
      return /^#quiz-[a-z0-9]+$/i.test(url.hash) || /^(?:\/[a-z]{2}(?:-[A-Z]{2})?)?\/pages\/start\/?$/.test(url.pathname);
    } catch (_) { return false; }
  }
  function update(node) {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;
    if (node.matches && node.matches('a[href]') && legacy(node)) node.setAttribute('href', target);
    node.querySelectorAll('a[href]').forEach(function (link) { if (legacy(link)) link.setAttribute('href', target); });
  }
  update(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(update);
    });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
})();
